import React, { Component } from "react";
import styled from "styled-components";
import { type FrontifyAsset } from "@frontify/frontify-finder";

import { getStaticUrl } from "js/config";
import { BlueButton } from "js/react/components/UiComponents";
import { Gap30 } from "js/react/components/Gap";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { FileType } from "js/core/utilities/fileSourcesAndTypes";
import { downloadFileFromFrontify } from "js/core/utilities/downloadFile";
import FrontifyFilePickerDialog from "js/react/components/Dialogs/FrontifyFilePickerDialog";

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #A9A9A9;
    padding: 30px 50px;
    margin-bottom: 30px;
`;

interface Props {
    fileTypes: FileType[],
    handleImportedFile: (file: File) => void,
}

export default class FrontifyPicker extends Component<Props> {
    openPicker = () => {
        ShowDialog(FrontifyFilePickerDialog, {
            callback: async (assets: FrontifyAsset[]) => {
                const file = await downloadFileFromFrontify({
                    url: assets[0].dynamicPreviewUrl,
                    name: assets[0].filename
                });
                this.props.handleImportedFile(file);
            }
        })
    }

    render() {
        return (
            <Container id="finderModal">
                <img src={getStaticUrl("/images/file_hosting/frontify.svg")} width={50} height={50} />
                <Gap30 />
                {/* @ts-ignore */}
                <BlueButton onClick={this.openPicker}>
                    Select File from Frontify
                </BlueButton>
            </Container>
        );
    }
}
